import { defineComponent } from '@vue/composition-api';
import MyPage from './index.vue';
export default defineComponent({
  components: {
    MyPage: MyPage
  }
});